import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/product',
    component: () => import('../views/Product.vue'),
    children: [
      {
        path: '',
        name: 'product',
        component: () => import('../views/products/businessManage.vue')
      },
      {
        path: 'businessManage',
        component: () => import('../views/products/businessManage.vue')
      },
      {
        path: 'financeManage',
        component: () => import('../views/products/financeManage.vue')
      },
      {
        path: 'manageDecision',
        component: () => import('../views/products/manageDecision.vue')
      }
    ]
  },
  {
    path: '/case',
    name: 'Case',
    component: () => import('../views/Case.vue'),
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/Service.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News.vue')
  },
  {
    path: '/IcpPages',
    name: 'IcpPages',
    component: () => import('../views/IcpPages.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/caseItem',
    name: 'caseItem',
    component: () => import('../views/cases/caseItem.vue')
  },
  {
    path: '/inforItem',
    name: 'inforItem',
    component: () => import("../views/infors/inforItem.vue")
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})


router.afterEach(() => {
  window.scrollTo({
    top: 0,
    left: 0,
  });
});
export default router